import { render } from "./HiFileSize.vue?vue&type=template&id=c3dbb4b4"
import script from "./HiFileSize.vue?vue&type=script&lang=js"
export * from "./HiFileSize.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__